import { toast } from "extensions/toast";

import strings from "common/strings";
import { emitter } from "common/emitter";
import { store } from "common/store";
import { Qualifiers } from "common/components/queryBuilder/qualifiers";

import { Dialog } from "common/components/dialog/dialog";
import { pazienHistory } from "common/components/pazienHistory";

import { SAVE_AS_COMPARISON_REPORT } from "common/actions/comparison";
import { SAVE_AS_BENCHMARKS_REPORT } from "common/actions/benchmarks";

import { RESET_SLICE } from "common/reducers/merchant_reports";

import { SaveReportContent } from "./saveReportContent";

const addBuRefQualifier = function(currentQualifiers) {
    const bu_ref = store.getState().common.bu_ref;
    if (bu_ref) {
        const newQualifiers = new Qualifiers({
            value: currentQualifiers
        });
        // Inject bu as a filter
        newQualifiers.add(`bu:${bu_ref}`);
        return newQualifiers.toString();
    }
    
    return currentQualifiers;
};

export const saveReport = function({
    report_type, name, model, dates
}) {
    const saveDialogContent = new SaveReportContent({
        name,
        dates
    });
    
    Dialog.show({
        title: strings.reports_saveReport_title,
        buttons: [{
            role: "secondary",
            className: "dismiss",
            dismiss: true,
            caption: strings.cancel
        }, {
            role: "primary",
            caption: strings.reports_save_button,
            onClick() {
                if (saveDialogContent.validate()) {
                    // Reset saved reports store to refetch the reports on render
                    store.dispatch(RESET_SLICE());
                    
                    switch (report_type) {
                    case "regular": {
                        // Clone a provided model
                        const attrs = model.toJSON();
                        delete attrs._id;
    
                        attrs.qualifiers = addBuRefQualifier(attrs.qualifiers);
    
                        const newReport = new model.constructor(attrs);
    
                        newReport.set({
                            dates: saveDialogContent.state.selected_daterange,
                            datetype: dates.datetype.value,
                            name: saveDialogContent.getNewReportName()
                        });
    
                        newReport.save(null).then(() => {
                            saveDialogContent.parent.dismiss();
                            toast.success(strings.reports_save_success_message);
    
                            pazienHistory.navigateWithParams(`reports/${newReport.get("section_id")}/${newReport.id}`, {
                                trigger: true
                            });
                            emitter.emit("tracking.track", {
                                type: "report_created",
                                data: {
                                    dates: saveDialogContent.state.selected_daterange,
                                    datetype: dates.datetype.value,
                                    name: newReport.get("name")
                                }
                            });
                        }).catch(() => {
                            toast.error(strings.reports_save_error_message);
                        });
                    
                        break;
                    }
                    case "comparison": {
                        const payload = {
                            dates: saveDialogContent.state.selected_daterange,
                            datetype: dates.datetype.value,
                            name: saveDialogContent.getNewReportName(),
                            type: report_type,
                            qualifiers: addBuRefQualifier(model.qualifiers),
                            segments: model.segments,
                            metrics: model.metrics,
                            expanded_metric: model.expanded_metric,
                            pivot_table_structures: model.pivot_table_structures
                        };
                        
                        SAVE_AS_COMPARISON_REPORT(payload).then(() => {
                            saveDialogContent.parent.dismiss();
                        });
                    
                        break;
                    }
                    case "benchmarks": {
                        const payload = {
                            dates: saveDialogContent.state.selected_daterange,
                            datetype: dates.datetype.value,
                            name: saveDialogContent.getNewReportName(),
                            type: report_type,
                            qualifiers: addBuRefQualifier(model.qualifiers),
                            segments: model.segments,
                            metrics: model.metrics,
                            expanded_metric: model.expanded_metric,
                            pivot_table_structures: model.pivot_table_structures
                        };
                        SAVE_AS_BENCHMARKS_REPORT(payload).then(() => {
                            saveDialogContent.parent.dismiss();
                        });
                    
                        break;
                    }
                    default: { break; }
                    }
                }
            }
        }],
        shouldFocusPrimaryButton: false,
        content: saveDialogContent,
        render: true
    });
};
